export const ICON_CLASS_NAME = 'Tab__icon';
